<template>
  <div
    class="text-card"
    :class="{'pb-2': !value}"
  >
    <h5
      v-if="title"
      class="text-card__title"
    >
      {{ title }}
    </h5>

    <div class="text-card__content">
      <slot v-if="disabled && !textValue" />

      <v-textarea
        v-else
        v-model="textValue"
        :rules="required ? [rules.required] : []"
        outlined
        min-height="160"
        :readonly="disabled"
      />
    </div>
  </div>
</template>

<script>
import rules from '@/helpers/validators';

export default {
  props: {
    value: {
      required: true,
      validator: (prop) => typeof prop === 'string' || prop === null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      rules,
    };
  },

  computed: {
    textValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.text-card {
  background: #FFFFFF;
  box-shadow: 0px 3px 6px $shadow-key-umbra-opacity;
  border-radius: 2px;
  padding: 24px 32px 0;

  &__title {
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 16px;
  }
}
</style>
